export default "__VITE_ASSET__CR_k$v7f__"